





























import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { addRemark, getTopicGroup } from '@/api/exam/topicGroup'
import TopicGroupDetailsEmpty from '@/apps/exam/views/topicgroup/components/TopicGroupDetailsEmpty.vue'
import CreateTopicPart from '@/apps/exam/views/topicgroup/components/CreateTopicPart.vue'
import CreateTopicPartList from '@/apps/exam/views/topicgroup/components/CreateTopicPartList.vue'

import { State, Action, Getter, namespace } from 'vuex-class'
const TopicPart = namespace('app-exam/topicPart')
import TopicGroup, { TopicPart } from '@/model/exam/topicGroup'
@Component({
  components: { TopicGroupDetailsEmpty, CreateTopicPart, CreateTopicPartList }
})
export default class CreateTopic extends Vue {
  @TopicPart.State('topicParts') topicParts!: TopicPart[]
  @TopicPart.Action('queryTopicPart') queryTopicPart!: Function

  private remarkText: string = '哈哈'
  private topicCategory?: string = ''
  private isRandom?: boolean = false
  private topicNumbers?: number = 0
  private topicGroupId: string = ''
  private isLOading: boolean = false
  private isEmpty: boolean = true
  private createTopicPartVisable: boolean = false
  private isSuccessStart: boolean = false
  private isSuccessEnd: boolean = true
  private isSuccessText: boolean = true
  private topicGroup: TopicGroup = {
    remarks: [
      {
        startScore: '0',
        endScore: '59',
        remark: '不及格呀大兄弟，需要重考'
      }
    ]
  }
  @Watch('topicParts')
  async initData() {
    // this.topicGroupId = this.$route.query.topicGroupId as string
    // await this.queryTopicPart(this.topicGroupId)
    //查询判断是否有计划
    if (this.topicParts && this.topicParts.length > 0) {
      this.isEmpty = false
    }
  }
  async mounted() {
    this.topicGroupId = this.$route.query.topicGroupId as string
    await this.queryTopicPart(this.topicGroupId)
    if (this.topicParts && this.topicParts.length > 0) {
      this.isEmpty = false
    } else {
      this.isEmpty = true
    }
    //查寻试卷
    // this.topicGroup = await getTopicGroup(this.topicGroupId)
    // //判断试卷有没有题目

    // if (
    //   this.topicGroup &&
    //   this.topicGroup.topicIds &&
    //   this.topicGroup.topicIds.length > 0
    // ) {
    //   this.isEmpty = false
    // } else {
    //   this.isEmpty = true
    // }
  }
  createTopic() {
    this.createTopicPartVisable = true
  }
  closeCreateTopicPart() {
    this.createTopicPartVisable = false
  }
  confirmCreateTopicPart() {
    this.createTopicPartVisable = false
  }
  async back() {
    this.$router.push({
      path: '/exam/group/topicgroup'
    })
  }
}
